module.exports = __webpack_public_path__ + "img/icon-0.414bb50d.jpg";